// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"RecipePop_ConfirmationPop__CI7YC","modalBody":"RecipePop_modalBody__cmlfc"};